import React, { useContext, useEffect, useState } from 'react';

// Components //
import Modal from '../../ui/modal/Modal'
import Button from '../../atoms/button/button';

// Styles //
import './WelcomeLeader.scss'

// Services //
import { getToken } from '../../../services/social.services';
import { getUserFormDataByQuestionId } from '../../../services/formServices';

// Context //
import GlobalContext from "../../../contexts/globalContext";

interface DataLeader {
    picture: string;
    fullName: string;
}

export default function WelcomeLeader() {

    const [dataLeader, setDataLeader] = useState<DataLeader>();
    const Context = useContext(GlobalContext);

    // Funcion para el boton cerrar del modal
    const closeModal = () => {
        Context.showModalNewLeader?.set(false);
    };


    useEffect(() => {
        async function fetchDataLeader() {
            if (Context?.gigyaContext?.gigyaAccount?.data.docNumber) {
                const token = await getToken(Context?.gigyaContext?.gigyaAccount?.UID);
                const dataFormLeader = await getUserFormDataByQuestionId(token, 5, "documentId", Context?.gigyaContext?.gigyaAccount?.data.docNumber);
                setDataLeader({
                    fullName: dataFormLeader?.data?.answerData?.name,
                    picture: Context.gigyaContext.gigyaAccount.profile.photoURL
                });
            }
        }
        fetchDataLeader();
    }, [Context?.gigyaContext])

    // Deshabilita el scroll cuando el form es visible
    useEffect(() => {
        document.body.style.overflow = Context.showModalNewLeader?.get ? "hidden" : "unset";
    }, [Context.showModalNewLeader?.get]);

    return (
        <GlobalContext.Consumer>
            {
                (data) =>
                    (data.showModalNewLeader?.get && (
                        <Modal showModal={data.showModalNewLeader?.get} onClose={() => closeModal()} >
                            <div className='m-modal-bienvenida'>
                                <div className='m-modal-bienvenida-box'>
                                    <div className='picture-leader'>
                                        <img src={dataLeader?.picture} alt="alternative" />
                                    </div>
                                    <p className='name-leader'>{dataLeader?.fullName}</p>
                                    <p className='description'>Te damos la bienvenida a nuestra comunidad {'\n'} Red de lideres</p>
                                </div>

                                <Button 
                                    type='button' 
                                    classname={'a-button__magenta'} 
                                    text={'ver red de lideres'} 
                                    isDisabled={undefined} 
                                    onClickAction={() => data.showModalNewLeader}
                                 />
                            </div>
                        </Modal>))

            }

        </GlobalContext.Consumer>
    )
}
